export const RoofExitIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       stroke="currentColor" strokeWidth={size < 22 ? 2.2 : 2}
       strokeLinecap="round" strokeLinejoin="round"
       role="img" {...props}>
    <title>Roof emergency exit</title>
    <path d="M6 11.2 18.4 5.6" strokeWidth="2.6" />
    <circle cx="12" cy="12.4" r="1.9" fill="currentColor" stroke="none" />
    <path d="M12 14.3v5.5" strokeWidth="2.4" />
    <path d="M11.2 15.4 8.6 13.2 8.2 10.4" />
    <path d="M12.8 15.4 15.4 12.8 16.1 7.4" />
    <path d="M2.5 19.8H9" />
    <path d="M15 19.8h6.5" />
  </svg>
);

export const RearExitIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
     stroke="currentColor" strokeWidth={size < 22 ? 2.2 : 2} stroke-linecap="round" stroke-linejoin="round"
     role="img" aria-label="Emergency exit" {...props}
    >
    <title>Rear emergency exit</title>
    <path d="M13.8 2.6h7.6v18.8h-7.6" stroke-width="1.8"/>
    <path d="M15.4 8.2h4.4" stroke-width="1.8"/>
    <path d="m17.8 6 2.2 2.2-2.2 2.2" stroke-width="1.8"/>
    <circle cx="6.6" cy="4.6" r="2.5" fill="currentColor"/>
    <path d="M6.4 8.2 8.8 12.6" stroke-width="3.4"/>
    <path d="M7.6 9.2 12.4 7.6" stroke-width="2.9"/>
    <path d="M6.8 9.6 3.6 12.2" stroke-width="2.9"/>
    <path d="M8.8 12.6 11.4 15.4 11 19.8" stroke-width="3"/>
    <path d="M8.8 12.6 6 15.4 2.9 16.6" stroke-width="3"/>
</svg>
);